
import permission from './permission';

const directives = [
    permission
];

const install = function(Vue, opts = {}) {
    opts; //这个没用，可以删除。
    directives.forEach(directive => {
      directive.install(Vue);
    });
};
  
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}
  
export default {
    version: '1.0.0',
    install
};
  
